import H from 'history'
import React from 'react'
import { EntitledToView } from '../entitlements/EntitledToView'
import { BreachEvent } from 'common/events/breachEventTypes'
import { useFeature } from 'common/feature-togglings/features'
import { BreachNotificationWrapper } from './components/BreachNotificationWrapper'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import {
    StyledFeatureArticleBreachNotification,
    StyledFeatureArticleBreachWrapper,
} from './FeatureArticleBreach.styled'

export interface Props {
    isPremium: boolean
    location: H.Location
    commonElements: React.ReactElement<any>
    slug: string
    onEvent: (event: BreachEvent) => void
    publicationId: string
}

const appendAdditionalVariant = (isSimpleSubsFormEnabled: boolean, creativeName: string) =>
    isSimpleSubsFormEnabled ? `${creativeName}_SimpleDigital'}` : creativeName

export const FeatureArticleBreach: React.FC<Props> = props => {
    const { commonElements, isPremium, location, onEvent, slug } = props

    const isSimpleSubsFormEnabled = useFeature('simple-digital-subscription-form')

    const creativeName = 'launch - no content'
    const deal = 'launch deal'

    return (
        <EntitledToView
            isPremium={isPremium}
            articleSlug={slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent
            )}
            entitled={() => {
                return (
                    <StyledFeatureArticleBreachWrapper showBackground={false}>
                        {commonElements}
                        {props.children}
                    </StyledFeatureArticleBreachWrapper>
                )
            }}
            notEntitled={() => {
                return (
                    <StyledFeatureArticleBreachWrapper showBackground={props.isPremium}>
                        {commonElements}
                        <StyledFeatureArticleBreachNotification>
                            <BreachNotificationWrapper
                                breachDeal={deal}
                                articleId={props.publicationId}
                                breachCreativeName={appendAdditionalVariant(
                                    isSimpleSubsFormEnabled,
                                    creativeName
                                )}
                                onEvent={onEvent}
                            />
                        </StyledFeatureArticleBreachNotification>
                    </StyledFeatureArticleBreachWrapper>
                )
            }}
        />
    )
}

FeatureArticleBreach.displayName = 'FeatureArticleBreach'
